module.exports = __webpack_public_path__ + "static/img/p.ee56bb19.png";